import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vModelText as _vModelText, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/img/ingeteam_logo.png'


const _withScopeId = n => (_pushScopeId("data-v-18ce6af8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "data--center login__form__account" }
const _hoisted_2 = { class: "login__form_msg2" }
const _hoisted_3 = { class: "pi pi-info-circle" }
const _hoisted_4 = { class: "login__form__style" }
const _hoisted_5 = { style: {"height":"300px","margin-bottom":"1rem"} }
const _hoisted_6 = { class: "login__form__style" }
const _hoisted_7 = { style: {"height":"250px"} }
const _hoisted_8 = {
  class: "login__form__fields",
  style: {"height":"150px"}
}
const _hoisted_9 = {
  key: 0,
  class: "validation__error"
}
const _hoisted_10 = {
  key: 0,
  class: "pi pi-spin pi-spinner",
  style: {"font-size":"1.25rem"}
}
const _hoisted_11 = { class: "user__actions" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "loginform__logo",
  src: _imports_0
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.access && _ctx.access(...args)), ["prevent"])),
    class: "login__form"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t('login.welcomemsg2')), 1),
      _withDirectives(_createElementVNode("i", _hoisted_3, null, 512), [
        [
          _directive_tooltip,
          'INGECON SUN Monitor, INGECON SUN Planner',
          void 0,
          { bottom: true }
        ]
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _withDirectives(_createElementVNode("input", {
                type: "email",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.user.email) = $event)),
                name: "username",
                placeholder: "EMAIL",
                autocomplete: "username"
              }, null, 512), [
                [_vModelText, _ctx.user.email]
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "password",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.user.password) = $event)),
                name: "password",
                placeholder: "PASSWORD",
                autocomplete: "current-password"
              }, null, 512), [
                [_vModelText, _ctx.user.password]
              ]),
              (_ctx.error)
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.$t(_ctx.error)), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                type: "submit",
                class: "button__general login__wrapper__button border__rounded",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.access && _ctx.access(...args)))
              }, [
                (_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_10))
                  : _createCommentVNode("", true),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('login.loginbutton')), 1)
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.UpdateloginUserFormStatusData(_ctx.LoginUserFormStatus.RecoverUserPwd)))
              }, _toDisplayString(_ctx.$t('login.forgotpassword')), 1),
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.UpdateloginUserFormStatusData(_ctx.LoginUserFormStatus.RegisterUser)))
              }, _toDisplayString(_ctx.$t('login.registeruser')), 1)
            ])
          ])
        ])
      ]),
      _hoisted_12
    ])
  ], 32))
}